export enum ALLIANCE_TYPE_ENUMERATION {
  UPDATE = 'update',
}

export enum SIMULATION_PROPERTIES_ENUMERATION {
  AMOUNT = 'amount',
  TERM = 'term',
  QUOTA = 'quota',
}

export enum LOAN_STATE_ENUMERATION {
  NEW = 'isNewLoan',
}
